// extracted by mini-css-extract-plugin
export var hasDescription = "index-module--hasDescription--B7nHw";
export var hasLogo = "index-module--hasLogo--hTzv8";
export var mediaCard = "index-module--mediaCard--ZMY7S";
export var mediaContent = "index-module--mediaContent--10pFh";
export var mediaLeft = "index-module--mediaLeft--0fw5u";
export var mediaLink = "index-module--mediaLink--bbp6J";
export var noDescription = "index-module--noDescription--+aDP-";
export var noLogo = "index-module--noLogo--TR1qN";